import { reactive } from 'vue';

/* Global store */
const store = reactive({
	/* Whether the data has been loaded or not */
	ready: false,

	/* Full list of courses */
	courses: [],

	/* List of topics */
	topics: {},

	/* List of experiences */
	experiences: {},

	/* List of roles */
	roles: {},

	/* Current filters */
	filter: {
		topics: [],
		experiences: [],
		roles: [],
	},
});

export default {
	store,
	install(app) {
		app.config.globalProperties.$store = store;
	},
};
